// extracted by mini-css-extract-plugin
module.exports = {"Hourglass":"Spinner_Hourglass__3qWoc","lds-hourglass":"Spinner_lds-hourglass__8cIdZ"};